<template>
  <div
    class="
      col-span-6
      sm:col-span-3
      xl:col-span-2
      flex flex-col
      justify-end
      items-center
    "
    v-show="loading"
  >
    <LoadingIcon icon="three-dots" class="w-8 h-8" />
  </div>
  <div>
    <form class="validate-form" @submit.prevent="handleSave" v-show="!loading">
      <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
        <UsersIcon />
        <h2 class="text-lg font-medium mr-auto">{{ $t('admin.addEmployee') }}</h2>
        <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
          <button
            type="submit"
            class="btn btn-primary shadow-md flex items-center"
          >
            <SaveIcon class="w-4 h-4 mr-2" /> {{ $t('common.save') }}
          </button>
          <router-link
            :to="{ name: 'side-menu-employees' }"
            tag="a"
            class="btn shadow-md flex items-center"
          >
            <ArrowLeftCircleIcon class="w-4 h-4 mr-2" /> {{ $t('common.back') }}
          </router-link>
        </div>
      </div>
      <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
        <!-- BEGIN: Post Info -->
        <div class="col-span-12">
          <div class="intro-y box p-5">
            <div class="mt-3">
              <label
                for="name"
                class="form-label w-full flex flex-col sm:flex-row"
              >
                {{ $t('common.personName') }}
                <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                  {{ $t('form.required') }},
                  {{ $t('form.constraint.gte2ch') }}
                </span>
              </label>
              <input
                id="name"
                v-model.trim="validate.name.$model"
                type="text"
                name="name"
                disabled="disabled"
                class="
                  intro-y
                  form-control
                  py-3
                  px-4
                  box
                  pr-10
                  placeholder-theme-13
                "
                :class="{ 'border-theme-6': validate.name.$error }"
                placeholder="John"
              />
              <template v-if="validate.name.$error">
                <div
                  v-for="(error, index) in validate.name.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ error.$message }}
                </div>
              </template>
            </div>
            <div class="mt-3">
              <label
                for="lastname"
                class="form-label w-full flex flex-col sm:flex-row"
              >
                {{ $t('common.personLastname') }}
                <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                  {{ $t('form.required') }},
                  {{ $t('form.constraint.gte2ch') }}
                </span>
              </label>
              <input
                id="lastname"
                v-model.trim="validate.lastname.$model"
                type="text"
                name="lastname"
                disabled="disabled"
                class="
                  intro-y
                  form-control
                  py-3
                  px-4
                  box
                  pr-10
                  placeholder-theme-13
                "
                :class="{ 'border-theme-6': validate.lastname.$error }"
                placeholder="Doe"
              />
              <template v-if="validate.lastname.$error">
                <div
                  v-for="(error, index) in validate.lastname.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ error.$message }}
                </div>
              </template>
            </div>
            <div class="mt-3">
              <label
                for="phoneNumber"
                class="form-label w-full flex flex-col sm:flex-row"
              >
                {{ $t('common.phoneNumber') }}
                <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                  {{ $t('form.required') }},
                  {{ $t('form.constraint.phoneFormat') }}
                </span>
              </label>
              <input
                id="phoneNumber"
                v-model.trim="validate.phoneNumber.$model"
                type="text"
                name="phoneNumber"
                class="
                  intro-y
                  form-control
                  py-3
                  px-4
                  box
                  pr-10
                  placeholder-theme-13
                "
                :class="{ 'border-theme-6': validate.phoneNumber.$error }"
                placeholder="+421xxxyyyzzz"
              />
              <template v-if="validate.phoneNumber.$error">
                <div
                  v-for="(error, index) in validate.phoneNumber.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
            <div class="mt-3">
              <label
                for="email"
                class="form-label w-full flex flex-col sm:flex-row"
              >
                Email
                <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                  {{ $t('form.required') }}
                </span>
              </label>
              <input
                id="email"
                v-model.trim="validate.email.$model"
                type="text"
                name="email"
                class="
                  intro-y
                  form-control
                  py-3
                  px-4
                  box
                  pr-10
                  placeholder-theme-13
                "
                :class="{ 'border-theme-6': validate.email.$error }"
                placeholder="info@info.info"
              />
              <template v-if="validate.email.$error">
                <div
                  v-for="(error, index) in validate.email.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- END: Post Info -->
      </div>
    </form>
  </div>
  <!-- BEGIN: Success Notification Content -->
  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('employee.createdAccess') }}!</div>
      <!-- <div class="text-gray-600 mt-1">
        Please check your e-mail for further info!
      </div> -->
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('employee.notCreatedAccess') }}!</div>
      <!-- <div class="text-gray-600 mt-1">Please check the fileld form.</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div
    id="failed-load-notification-content"
    class="toastify-content hidden flex"
  >
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('employee.notLoaded') }}!</div>
      <!-- <div class="text-gray-600 mt-1">Please check the fileld form.</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, ref, toRefs, reactive } from 'vue'
import { required, minLength, helpers, email } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Toastify from 'toastify-js'
import employeeApi from '@/services/employees/employee.api'
import adminApi from '@/services/admin-users/admin.api'

export default defineComponent({
  components: {},
  methods: {
    handleSave(data) {
      this.loading = true

      this.validate.$touch()
      if (this.validate.$invalid) {
        Toastify({
          node: cash('#failed-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.loading = false
        return
      }

      const saveRequest = {
        name: this.employee.name,
        lastname: this.employee.lastname,
        phoneNumber: data.target.elements.phoneNumber.value,
        email: data.target.elements.email.value,
        password: '',
        employeeUUID: this.employee.uuid
      }

      adminApi.createEmployeeAccess(saveRequest).then(
        response => {
          Toastify({
            node: cash('#success-notification-content')
              .clone()
              .removeClass('hidden')[0],
            duration: 5000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.$router.push({ name: 'side-menu-employees' })
        },
        error => {
          console.log(error)
          this.loading = false
          Toastify({
            node: cash('#failed-notification-content')
              .clone()
              .removeClass('hidden')[0],
            duration: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
        }
      )
    }
  },
  computed: {
    console: () => console
  },
  data() {
    return {
      employee: {}
    }
  },
  mounted() {
    employeeApi.getDetail(this.$route.params.uuid).then(
      response => {
        this.employee = response.data
        this.formData.name = response.data.name
        this.formData.lastname = response.data.lastname
        this.formData.phoneNumber = response.data.phoneNumber
        this.formData.email = response.data.email

        this.loading = false
      },
      error => {
        console.log(error)
        this.loading = false
        Toastify({
          node: cash('#failed-load-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.$router.push({ name: 'side-menu-employees' })
      }
    )
  },
  setup() {
    const loading = ref(true)
    const selectedBranches = ref([])
    const selectedServices = ref([])
    const address = ref({})

    const phoneNumberValidator = helpers.regex(/^\+421[0-9]{9}$/)
    const formData = reactive({
      name: '',
      lastname: '',
      phoneNumber: '',
      email: ''
    })
    const rules = {
      name: {
        required: helpers.withMessage(
          'form.validation.personName.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      lastname: {
        required: helpers.withMessage(
          'form.validation.personLastname.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      phoneNumber: {
        required: helpers.withMessage(
          'form.validation.phoneNumberRequired',
          required
        ),
        phoneNumberValidator: helpers.withMessage(
          'form.validation.phoneNumberValidator',
          phoneNumberValidator
        )
      },
      email: {
        required: helpers.withMessage(
          'form.validation.emailRequired',
          required
        ),
        email: helpers.withMessage('form.validation.email', email)
      }
    }
    const validate = useVuelidate(rules, toRefs(formData))

    return {
      loading,
      address,
      validate,
      formData,
      selectedBranches,
      selectedServices
    }
  }
})
</script>
